
import { useEffect, useState } from 'react';
import { FeatureContext } from '../../Context';
import { getProjects } from './Services';
import Projects from "./Projects";
import { ChakraProvider } from '@chakra-ui/react';
import { Error } from '../../components/error/Error';
import { NoDataFound } from '../../ErrorType';

const Index = () => {
  const [mounted, setMounted] = useState(false);
  const [state, setState] = useState({
    loading: false,
    error: '',
    projects: {},
    setProjects: (value) => setState(prevState => ({ ...prevState, projects: value })),
    setLoading: {
      on: () => setState(prevState => ({ ...prevState, loading: true })),
      off: () => setState(prevState => ({ ...prevState, loading: false })),
    },
    setError: (value) => setState(prevState => ({ ...prevState, error: value })),
  });

  useEffect(() => {

    if (!mounted) state.setLoading.on();

    getProjects()
      .then(data => {
        state.setProjects(data);
        if (!mounted) {
          state.setLoading.off();
          setMounted(true);
        }
      })
      .catch(error => {
        if (error instanceof NoDataFound) {
          state.setProjects([]);
        } else {
          state.setError(error);
        }
        if (!mounted) {
          state.setLoading.off();
          setMounted(true);
        }
      });
  }, []);

  const render = () => {
    if (state.error) {
      return <Error error={state.error}/>
    } else {
      return <Projects />
    }
  }

  return <ChakraProvider>
    <FeatureContext.Provider value={state}>
      {render()}
    </FeatureContext.Provider>
  </ChakraProvider>

}

export { Index }
